import APIService from './APIService';
import config from '../../config';
import { objectToQueryParams } from '../helpers/common';
import store from '../store';
let link = config.baseUrlForMailSync;
export default class MailSyncService extends APIService {
  /**
   * Get all mail sync execution for Org.
   *
   * @param {object} params
   * Example params -> {
   *    "orgId": "string",
   *    "pageNumber": 0,
   *    "pageSize": 0,
   *    "sort": {
   *        "sortBy": "REQUESTED_TIME",
   *        "sortOrder": "ASCENDING"
   *    },
   *    "status": "REQUESTED"
   * }
   */

  static getMailSyncExecutions(params) {
    const url = `${link}/mail/synchronize/executions`;
    return this.post(url, params);
  }

  /**
   * @param {string} id
   */
  static getMailSyncExecution(id) {
    const url = `${link}/mail/synchronize/execution/${id}`;
    return this.get(url);
  }

  /**
   * @param {string} id
   */
  static getMailSyncExecutionReport(id) {
    const url = `${link}/mail/synchronize/execution/${id}/fullReport`;
    return this.get(url);
  }
  /**
   * @param {string} id
   */
  static approveMail(id) {
    const url = `${link}/mail/synchronize/execution/${id}/approve`;
    return this.post(url);
  }

  /**
   * Request a execution
   * @param {string} id
   */
  static reuqestExecution({ urlParams, params }) {
    let url = `${link}/mail/synchronize/execution`;
    if (urlParams) {
      url += '?' + objectToQueryParams(urlParams);
    }
    return this.post(url, params);
  }

  static requestMailSync({ orgId = store.state.orgId }) {
    let url = `${link}/mail/synchronize/subscription?${objectToQueryParams({
      orgId,
    })}`;
    return this.post(url);
  }
}
